import type { Sticker } from '../types';

export const shower: Sticker[] = [
  {
    id: 28001,
    url: 'https://stickers.nauczniaczek.pl/colections/14884001-shower/png/001-dental-hygiene.png',
    name: 'Higiena Jamy Ustnej',
    category: 'shower',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 28002,
    url: 'https://stickers.nauczniaczek.pl/colections/14884001-shower/png/002-wellness.png',
    name: 'Wellness',
    category: 'shower',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 28003,
    url: 'https://stickers.nauczniaczek.pl/colections/14884001-shower/png/003-bathrobe.png',
    name: 'Szlafrok',
    category: 'shower',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 28004,
    url: 'https://stickers.nauczniaczek.pl/colections/14884001-shower/png/004-mirror.png',
    name: 'Lustro',
    category: 'shower',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 28005,
    url: 'https://stickers.nauczniaczek.pl/colections/14884001-shower/png/005-shower.png',
    name: 'Prysznic',
    category: 'shower',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 28006,
    url: 'https://stickers.nauczniaczek.pl/colections/14884001-shower/png/006-towel.png',
    name: 'Ręcznik',
    category: 'shower',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 28007,
    url: 'https://stickers.nauczniaczek.pl/colections/14884001-shower/png/007-perfume-bottle.png',
    name: 'Perfumy',
    category: 'shower',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 28008,
    url: 'https://stickers.nauczniaczek.pl/colections/14884001-shower/png/008-comb.png',
    name: 'Grzebień',
    category: 'shower',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 28009,
    url: 'https://stickers.nauczniaczek.pl/colections/14884001-shower/png/009-facial-cream.png',
    name: 'Krem do Twarzy',
    category: 'shower',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 28010,
    url: 'https://stickers.nauczniaczek.pl/colections/14884001-shower/png/010-shower.png',
    name: 'Kabina Prysznicowa',
    category: 'shower',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 28011,
    url: 'https://stickers.nauczniaczek.pl/colections/14884001-shower/png/011-washing.png',
    name: 'Mycie',
    category: 'shower',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 28012,
    url: 'https://stickers.nauczniaczek.pl/colections/14884001-shower/png/012-handwashing.png',
    name: 'Mycie Rąk',
    category: 'shower',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 28013,
    url: 'https://stickers.nauczniaczek.pl/colections/14884001-shower/png/013-toilet.png',
    name: 'Toaleta',
    category: 'shower',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 28014,
    url: 'https://stickers.nauczniaczek.pl/colections/14884001-shower/png/014-shaver.png',
    name: 'Golarka',
    category: 'shower',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 28015,
    url: 'https://stickers.nauczniaczek.pl/colections/14884001-shower/png/015-mouthwash.png',
    name: 'Płyn do Płukania',
    category: 'shower',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 28016,
    url: 'https://stickers.nauczniaczek.pl/colections/14884001-shower/png/016-bath.png',
    name: 'Wanna',
    category: 'shower',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 28017,
    url: 'https://stickers.nauczniaczek.pl/colections/14884001-shower/png/017-shower.png',
    name: 'Słuchawka Prysznicowa',
    category: 'shower',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 28018,
    url: 'https://stickers.nauczniaczek.pl/colections/14884001-shower/png/018-shower.png',
    name: 'Deszczownica',
    category: 'shower',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 28019,
    url: 'https://stickers.nauczniaczek.pl/colections/14884001-shower/png/019-bath.png',
    name: 'Kąpiel',
    category: 'shower',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 28020,
    url: 'https://stickers.nauczniaczek.pl/colections/14884001-shower/png/020-shower.png',
    name: 'Łazienka',
    category: 'shower',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  }
];